<template>
  <div>
    <kbList />
  </div>
</template>

<script>
import kbList from "../components/knowledge-base/kb-list.vue";

export default {
  name: "KnowledgeBasePage",
  components: {
    kbList,
  },
};
</script>
